import Icon from 'assets/Icons';
import colorTheme from 'constants/color';
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { formatPhone, maskPhone } from 'utils/formatPhone';
import CustomerPopoverCheckPinCode from '../../../CustomerPopoverCheckPinCode';
import PinCodeModal, { PinCodeModalRef } from '../../../PinCodeModal';
import { formatDate } from './helpers';
import lockIcon from './lock-icon.svg';
import unlockIcon from './unlock-icon.svg';

type Props = {
  id?: string;
  name?: string;
  phone?: string;
  date?: string;
  centered?: boolean;
};

const CustomerSummary: React.FC<Props> = ({ id, name, phone, date, centered = false }) => {
  const pinCodeModalRef = useRef<PinCodeModalRef>(null);
  const [isMasked, setIsMasked] = useState(true);

  const onToggleMasked = () => {
    if (!isMasked) return setIsMasked(true);
    pinCodeModalRef.current?.open(() => {
      setIsMasked(false);
    });
  };
  return (
    <Wrapper $centered={centered}>
        <CustomerPopoverCheckPinCode
          customerName={name || ''}
          customerId={id || ''}
        />
        <ButtonMask type='button' onClick={onToggleMasked}>
          <Value style={{ color: '#6FABB6', fontSize: '18px', fontWeight: 'bold' }}>
            {phone
              ? isMasked ? maskPhone(phone) : formatPhone(phone)
              : '--'}
          </Value>
          <img src={isMasked ? lockIcon : unlockIcon} alt="lockIcon" style={{ width: 32, height: 32 }} />
        </ButtonMask>
      <div className="date-chip">
        <Icon type="calendar" />
        <span>{formatDate(date)}</span>
      </div>
      <PinCodeModal ref={pinCodeModalRef} title='ADMIN PASSWORD' />
    </Wrapper>
  );
};

export default CustomerSummary;
const ButtonMask = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Value = styled.div`
  color: #1d2129;
`;

const Wrapper = styled.div<{ $centered?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  align-self: stretch;
  ${({ $centered }) =>
    $centered
      ? `
    width: 100%;
    align-items: center;
  `
      : `
    width: 250px;
    flex-shrink: 0;
    padding-right: 24px;
    border-right: 1px solid ${colorTheme.v2_neutral_4};
  `}

  .info {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
    ${({ $centered }) => ($centered ? 'align-items: center;' : '')}
  }
  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${colorTheme.v2_text_5};
    font-family: Poppins;
    font-size: 24px;
    font-weight: 600;
    ${({ $centered }) => ($centered ? 'text-align: center; width: 100%;' : '')}
  }
  .phone-row {
    display: flex;
    align-items: center;
    gap: 8px;
    ${({ $centered }) => ($centered ? 'justify-content: center;' : '')}
  }
  .phone {
    color: ${colorTheme.v2_text_4};
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
    white-space: nowrap;
  }
  .eye {
    display: flex;
    align-items: center;
    color: ${colorTheme.v2_text_4};
    cursor: pointer;
  }

  .date-chip {
    display: flex;
    align-items: center;
    gap: 9px;
    align-self: ${({ $centered }) => ($centered ? 'center' : 'flex-start')};
    padding: 4px 8px;
    border-radius: 8px;
    margin-top: 8px;
    background: ${colorTheme.v2_secondary_6};
    span {
      color: ${colorTheme.v2_text_5};
      font-family: Poppins;
      font-size: 16px;
      font-weight: 600;
      white-space: nowrap;
    }
  }
`;
